var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view"},[_c('video',{attrs:{"id":"video","src":_vm.detail.video,"poster":_vm.detail.pic,"controls":"","controlsList":"nodownload noplaybackrate","disablePictureInPicture":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }